import styled from 'styled-components';
import color from '../../../config/colors.json';

export const SpecialProjectContent = styled.div`
    font-family: 'Poppins', sans-serif;

    .header {
        margin-bottom: 30px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;

        h1 {
            font-size: 18px;
            color: ${color.dark};
            font-weight: 600;
            margin: 0px;
            line-height: 35px;
        }
    
        h2 {
            font-size: 14px;
            color: ${color.grey};
            font-weight: normal;
            margin: 0;
        }
    }

    .card-special-project{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 30px;

        .content-header{
            color: ${color.dark};
            text-align: left;

            img {
                display: none;
            }

            h4 {
                font-size: 16px;
            }

        }

        h5 {
            font-size: 12px;
            color: ${color.grey};
        }

        .content-body{
            margin: 10px 0px 0px 0px;
            text-align: left;

            p {
                font-size: 12px;
                color: ${color.grey};
            }

            .text-black {
                color: ${color.dark};
                margin: 0px;
            }
        }

        label {
            color: ${color.dark};
            width: 100%;
            margin-bottom: 10px;
            font-size: 14px;
        }
    }

    .input-number{
        width: 59.69%;
        height: 24.97px;
        border: 1px solid #C5C6D0;
        padding: 5px;
        margin-bottom: 19.75px;
        margin-top: -6.47px;

        &:hover, &:focus, &:active{
            outline: none;
        }
    }

    .input-file{
        width: 100%;
        border: 2px dashed ${color.lightGrey};;
        color: ${color.lightGrey};;
        margin-bottom: 20.07px;

        .align-self-start{
            text-align: left;
            margin: 0px;
            font-family: 'Poppins', sans-serif;
            font-size: 17px;
            margin-block-start: 0px;
            margin-block-end: 0px;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            padding-inline-start: 0px;
            margin-left: -25px;
        }

        .dropzone{
            text-align: center;
            margin-bottom: 27.48px;
            font-family: 'Poppins', sans-serif;
            color: ${color.lightGrey};;

            .arraste-as-imagens{
                font-size: 20px;
                color: ${color.lightGrey};;
            }

            p{
                font-size: 14px;
                color: ${color.lightGrey7};
            }

            .btn-primary{
                background-color: #EFEFEF;
                color: ${color.lightGrey7};
                font-size: 14px;
                box-shadow: 0px 2px 3px #00000029;
                border-radius: 2px;
                border: none;

                &:active, &:focus, &:hover{
                    background-color: #EFEFEF;
                    color: ${color.lightGrey7};
                    opacity: 0.8;
                }
            }
        }

        p {
          text-align: center;
          color: ${color.lightGrey7};
          font-size: 1.5em;
          margin-bottom: 15px;
        }
  
        .arraste-as-imagens {
          img {
            margin-top: 10px;
            margin-bottom: 15px;
          }
  
          p {
            text-align: center;
            color: ${color.lightGrey};;
            font-size: 16px;
            margin-bottom: 5px;
          }
        }
    }

    textarea{
        width: 100%;
        height: 150px;
        border: 1px solid #C5C6D0;
        padding: 5px;
        resize: none;

        &:hover, &:focus, &:active{
            outline: none;
        }
    }

    .textarea-count{
        display: flex;
        justify-content: flex-end;

        small{
            width: 100%;
            text-align: right;
        }

    }

`;
